import { classNames } from "primereact/utils"
import { useNavigate } from "react-router-dom"
import { ButtonOptions } from "../CardInfoSection"
import SmallLoader from "../../loaders/SmallLoader"

export type DocumentsButtonOptions = ButtonOptions & { numberOfDocuments?: number }

type DocumentButtonTemplateProps = {
    caption?: string
    buttonOptions: DocumentsButtonOptions
}

export function DocumentButtonTemplate({ caption, buttonOptions: { disabled, numberOfDocuments, isLoading } }: DocumentButtonTemplateProps) {
    const navigate = useNavigate()
    const onClickFunction = () => navigate('documents')

    const buttonClassnames = classNames({
        "button-div": true,
        "disabled": disabled || isLoading
    })

    return (
        <button disabled={disabled || isLoading} onClick={onClickFunction} className={buttonClassnames}>
            {isLoading
                ?
                <SmallLoader text="Загрузка..."/>
                :
                <>{caption} {`(${numberOfDocuments})`}</>
            }
        </button>
    )
}
